import { StyleSheet, View } from "react-native";
import { VideoCameraIcon } from "@phosphor-icons/react";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import {
  colors,
  radii,
  semanticColors,
  spacing,
  shadowStyles,
  typographyScale,
} from "../../../../styles/design-system";

export interface VideoCardProps {
  title?: string | null;
  onPress?: () => void;
}

export const VideoCard = ({ title, onPress }: VideoCardProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View style={styles.iconBox}>
          <VideoCameraIcon size={20} color={colors.brand[600]} />
        </View>
        <View style={styles.textArea}>
          <CustomText
            useTranslationText={false}
            text={title ?? "Video"}
            size="m"
            weight="bold"
            style={styles.titleText}
          />
        </View>
      </View>
      {onPress ? (
        <View style={styles.buttonRow}>
          <CustomButton
            style={styles.button}
            styleType="dark"
            onPress={onPress}
            text="Open Video"
            useTranslationText={false}
            leftIcon={null}
            rightIcon={null}
            accessibilityLabel="Open video activity"
            accessibilityRole="button"
          />
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: semanticColors.surface.white,
    borderRadius: radii.xl,
    borderWidth: 1,
    borderColor: colors.grey[200],
    marginTop: spacing.sm,
    marginBottom: spacing.sm,
    padding: spacing.lg,
    ...shadowStyles.sm,
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: spacing.md,
  },
  iconBox: {
    width: 40,
    height: 40,
    borderRadius: radii.lg,
    backgroundColor: colors.brand[50],
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  textArea: {
    flex: 1,
    minWidth: 0,
  },
  titleText: {
    color: colors.grey[900],
    fontSize: typographyScale.textBase.fontSize,
  },
  buttonRow: {
    marginTop: spacing.md,
  },
  button: {
    alignSelf: "flex-start",
    backgroundColor: colors.blue[600],
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
    borderRadius: radii.md,
    minHeight: 44,
  },
});
